import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {Opportunity} from '../../interfaces/opportunity.interface';
import {UntypedFormControl} from '@angular/forms';
import {Budget} from '../../../interfaces';
import {BudgetSelectorComponent} from '../budget-selector/budget-selector.component';
import {MatButton} from '@angular/material/button';



@Component({
    imports: [
        BudgetSelectorComponent,
        MatDialogTitle,
        MatButton
    ],
    template: `
        <h3 i18n mat-dialog-title>Reassign opportunity to another budget</h3>
        <app-budget-selector style="min-width: 220px"
                             [required]="true"
                             (budgetChange)="onBudgetChange($event)"
        ></app-budget-selector>

        <div>
            <button mat-button (click)="submit()" [disabled]="!budgetControl.value">Submit</button>
            <button mat-button (click)="onClose()">Close</button>
        </div>
    `
})
export class OpportunityChangeBudgetDialogComponent {
    budgetControl: UntypedFormControl;

    constructor(
        private dialogRef: MatDialogRef<OpportunityChangeBudgetDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public opportunity: Opportunity
    ) {
        this.budgetControl = new UntypedFormControl(null);
    }

    async onBudgetChange(b: Budget | null) {
        this.budgetControl.setValue(b);
    }

    submit() {
        this.dialogRef.close(this.budgetControl.value);
    }

    onClose(): void {
        this.dialogRef.close();
    }
}